'use client';
import { ensureNativeModulesAreInstalled } from './ensureNativeModulesAreInstalled';
ensureNativeModulesAreInstalled();
export const SharedRef = globalThis.expo.SharedRef;

//# sourceMappingURL=SharedRef.js.map
